import { quantityBus } from "@/event/product/quantityBus";
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";
import { showSelectedModalProductHappy } from "@/happyTheme/event/product/showSelectedModalProductHappy";
import { clearSelectOptionListHappy } from "./modal/clearSelectOptionListHappy";
import { relatedGroupBus } from "@/event/product/relatedGroupeBus";
import { productBus } from "@/event/product/productBus";
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass";

export function toggleSelectedModalProductHappy() {
    quantityBus.value = 1
    relatedGroupBus.value = []

    showSelectedModalProductHappy.value = !showSelectedModalProductHappy.value
    if (selectOptionsListHappy.value) {
        const timeOutClass = TimeOutClass.getInstance()
        const idTimeOut =
            setTimeout(() => {
                productBus.value = null
            }, 300)
        timeOutClass.setIdTimeout(idTimeOut)
        clearSelectOptionListHappy()
    }


}